import React from 'react';
import { Link } from 'react-router-dom';
import { trackEvent } from '../services/analytics';

const labelFor = (status) => ({
  available: 'Evidence available',
  partial: 'Limited evidence',
  unavailable: 'Not yet supported',
}[status] || status);

const IntelligenceSection = ({ id, eyebrow, title, module, children, distinct = false }) => {
  React.useEffect(() => {
    if (!module || typeof IntersectionObserver === 'undefined') return undefined;
    const node = document.getElementById(id);
    if (!node) return undefined;
    const observer = new IntersectionObserver(([entry]) => {
      if (entry.isIntersecting) {
        trackEvent('intelligence_section_expanded', { section: id, status: module.status });
        if (id === 'industry-lens') trackEvent('industry_lens_viewed', { status: module.status });
        observer.disconnect();
      }
    }, { threshold: 0.35 });
    observer.observe(node);
    return () => observer.disconnect();
  }, [id, module]);

  return (
    <section id={id} className={`ci-section ${distinct ? 'ci-section--industry' : ''}`}>
      <div className="ci-section__heading">
        <div>
          <p className="ci-eyebrow">{eyebrow}</p>
          <h2>{title}</h2>
        </div>
        <span className={`ci-status ci-status--${module?.status || 'unavailable'}`}>
          {labelFor(module?.status || 'unavailable')}
        </span>
      </div>
      {children}
      {module?.limitations?.length > 0 && (
        <div className="ci-limitations">
          {module.limitations.map((text, index) => <p key={index}>{text}</p>)}
        </div>
      )}
      <p className="ci-method-note">
        {module?.evidence?.length
          ? `Based on ${[...new Set(module.evidence.map((e) => e.source))].join(' and ')}.`
          : 'No sufficient supporting observation is stored.'}{' '}
        <Link to="/methodology">Methodology</Link>
      </p>
    </section>
  );
};

export default IntelligenceSection;
